import { Link } from "gatsby";
import capitalize from "lodash.capitalize";
import React from "react";
// eslint-disable-next-line  import/no-extraneous-dependencies
import { BreadcrumbList } from "schema-dts";
import { getSiteMetadata } from "../../graphQl/queries/getSiteMetadata";
import { IParentPage } from "../../types/IParentPage";
import JsonLD from "../JsonLd";
import "./styles.scss";
import { PanelWrapper } from "../PanelWrapper";

interface IBreadcrumbsJsonLD {
  pages: IParentPage[];
}

const BreadcrumbsJsonLD: React.FunctionComponent<IBreadcrumbsJsonLD> = ({
  pages,
}) => {
  const { siteUrl } = getSiteMetadata();

  return (
    <JsonLD<BreadcrumbList>
      data={{
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: pages.map((page, i) => ({
          "@type": "ListItem",
          item: `${siteUrl}${page.urlPath}`,
          name: page.shortTitle,
          position: i + 1,
        })),
      }}
    />
  );
};

interface IBreadcrumbsProps extends IParentPage {
  betterV2?: boolean;
}

const Breadcrumbs: React.FunctionComponent<IBreadcrumbsProps> = ({
  shortTitle,
  urlPath,
  parentPage,
  betterV2,
}) => {
  const pages: IParentPage[] = [];

  let current = parentPage;

  while (current) {
    if (!current.shortTitle) {
      const urlParts = current.urlPath.split("/");
      current.shortTitle = capitalize(
        urlParts[urlParts.length - 1].replace(/-/g, " "),
      );
    }
    pages.unshift(current);
    current = current.parentPage;
  }

  pages.push({ shortTitle, urlPath });

  return (
    <nav className="breadcrumbs__nav">
      <BreadcrumbsJsonLD pages={pages} />
      <PanelWrapper isBetterV2={betterV2} className="breadcrumbs__wrapper">
        <ol className={betterV2 ? "breadcrumbs-v2" : "breadcrumbs"}>
          {pages.map((page, i) => (
            <li key={i}>
              {i < pages.length - 1 ? (
                <Link to={page.urlPath} className={betterV2 ? "breadcrumbs-v2--link" : "tsl-link"}>
                  {page.shortTitle}
                </Link>
              ) : (
                page.shortTitle
              )}
            </li>
          ))}
        </ol>
      </PanelWrapper>
    </nav>
  );
};

export { Breadcrumbs, BreadcrumbsJsonLD };
